// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nN2ER","studentName":"styles_studentName__taAen","footer":"styles_footer__-HxHh","buttonFile":"styles_buttonFile__yUFOZ"};